import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { inject, nextTick, onMounted, ref } from "vue";
import { useUmbracoForm } from "@/store/useUmbracoForm";
import { FavoritesApi } from "@/services/Api";
import { Emitter } from "mitt";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTileWrapper',
  props: {
  requestForFileFormId: {
    type: String,
    required: true,
  },
  requestForPriceFormId: {
    type: String,
    required: true,
  },
  isFavorited: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const emitter = inject<Emitter<any>>("eventbus")!;
const umbracoForms = useUmbracoForm();


const isRequestForFileOpen = ref<boolean>(false);
const openRequestForFile = () => {
  isRequestForFileOpen.value = true;
};
const closeRequestForFile = () => {
  isRequestForFileOpen.value = false;
};

const isRequestForPriceOpen = ref<boolean>(false);
const openRequestForPrice = () => {
  isRequestForPriceOpen.value = true;
};
const closeRequestForPrice = () => {
  isRequestForPriceOpen.value = false;
};

const isFavorited = ref<boolean>(props.isFavorited);

const onFavoriteClick = (id: string) => {
  if (window.isLoggedIn) {
    isFavorited.value = !isFavorited.value;
    FavoritesApi.post(id, isFavorited.value).then(() => {
      nextTick(() => {
        if (isFavorited.value) {
          emitter.emit("favoriteAdded");
        } else {
          emitter.emit("favoriteRemoved");
        }
      });
    });
  } else {
    openLoginForm();
  }
};

const isLoginFormOpen = ref<boolean>(false);

const closeLoginForm = () => {
  isLoginFormOpen.value = false;
};

const openLoginForm = () => {
  isLoginFormOpen.value = true;
};

const loadUmbracoForms = () => {
  if (props.requestForFileFormId) {
    umbracoForms.get(props.requestForFileFormId);
  }

  if (props.requestForPriceFormId) {
    umbracoForms.get(props.requestForPriceFormId);
  }
};

onMounted(async () => {
  loadUmbracoForms();
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    isRequestForFileOpen: isRequestForFileOpen.value,
    openRequestForFile: openRequestForFile,
    closeRequestForFile: closeRequestForFile,
    requestForFileFormDefinition: _unref(umbracoForms).state[__props.requestForFileFormId],
    isRequestForPriceOpen: isRequestForPriceOpen.value,
    openRequestForPrice: openRequestForPrice,
    closeRequestForPrice: closeRequestForPrice,
    requestForPriceFormDefinition: _unref(umbracoForms).state[__props.requestForPriceFormId],
    onFavoriteClick: onFavoriteClick,
    isFavorited: isFavorited.value,
    isLoginFormOpen: isLoginFormOpen.value,
    openLoginForm: openLoginForm,
    closeLoginForm: closeLoginForm
  })
}
}

})